import { render, staticRenderFns } from "./native-ad.vue?vue&type=template&id=28203a4e&scoped=true"
import script from "./native-ad.vue?vue&type=script&lang=js"
export * from "./native-ad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28203a4e",
  null
  
)

export default component.exports